import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useI18n } from 'components/I18n';
import { Text } from 'components';
import { SkipLink } from './AppStyles';
import * as routerActions from 'router/actions';

const SkipNavigation = ({ handleSkipToContent, showSkipToSearch }) => {
  const i18n = useI18n();
  const dispatch = useDispatch();
  return (
    <nav aria-label={i18n.formatText('aria.navigation.skipLabel')}>
      <SkipLink href="#app-content" onClick={handleSkipToContent}>
        <Text id="aria.navigation.skipToContent" />
      </SkipLink>
      {showSkipToSearch && (
        <SkipLink
          href="/search"
          onClick={(e) => {
            e.preventDefault();
            dispatch(routerActions.push({ name: 'search' }));
          }}
        >
          <Text id="aria.navigation.skipToSearch" />
        </SkipLink>
      )}
    </nav>
  );
};

SkipNavigation.propTypes = {
  handleSkipToContent: PropTypes.func.isRequired,
  showSkipToSearch: PropTypes.bool,
};

export default SkipNavigation;
